
<div class="d-flex">
    @if (isPropertiesPage()) {
        <div role="button" (click)="navigateToListPage()"
            class="px-2 mb-3 animate__animated animate__bounceIn font-5 d-flex align-items-center clip3 position-relative me-1 fw-normal secondary-bg secondary-text-100 corner p-2">
            <span>Properties</span>
            <span class="material-icons-sharp font-5 ms-3">close</span>
        </div>
    }
    <breadcrumb [breadcrumbName]="constants.CATALOG" />
</div>
<div class="position-absolute export-panel">
    @if(tabData(); as tabData)
    {
        @if(tabData.length > 0)
        {
            <div class="m-0 p-0 pb-1 pe-1 px-2">
                <tabbed-card [tabData]="tabData" cardClass="static-full-width" cardAutoSize />
            </div>
        }
    }
</div>

<router-outlet></router-outlet>


